const VOUCHSAFE_SPEC_VERSION = "1.3.0";
export { VOUCHSAFE_SPEC_VERSION };
